module.exports = __webpack_public_path__ + "static/app-3-6369e53fe70f0f7dc717686cd42b386c.png";